import { faCoffee, faPodcast } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import { stat } from "fs";
import * as React from "react";
import "react-notifications-component/dist/theme.css";
import { Col, Container, Row } from "reactstrap";
import { Capitalize, showAlert } from "../common/functions";
import PromiseLandDetail from "./promiseLandDetail";
import PromiseLandList from "./promiseLandList";

class PromiseLandPageComponent extends React.Component {
	state = {
		isView: false,
		selectedId: false,
		page: "",
		id: 0,
		title: "",
	};
	constructor(props: any) {
		super(props);
		var tokenstr = (new URLSearchParams(window.location.search)).get("page");
		let tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? 0 : parseInt(idstr);
		this.state = {
			isView: false,
			selectedId: false,
			page: tValue,
			id: id,
			title: "Create New",
		}
		this.handleCallbackMethod = this.handleCallbackMethod.bind(this);
	}

	componentDidMount() {
		var tokenstr = (new URLSearchParams(window.location.search)).get("page");
		let tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var idChannelstr = localStorage.getItem("channelId");
		var channelId = idChannelstr === null ? 0 : parseInt(JSON.parse(idChannelstr));
		var id = idstr === null ? 0 : parseInt(idstr);
		var pageValue = id === 0 ? tValue : "detail";
		this.setState({
			...stat,
			page: pageValue,
			id: id,
			title: "",
			isView: pageValue === "" ? true : false,
			channelId: channelId
		});

		var alertMessage = window.localStorage.getItem("alertMessage");
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem('alertMessage', "");
		}

		document.title = `${pageValue === "" ? "Contextual Media" : "Contextual Media"
			} - Daily Audio Bible Administration`;
	}

	handleCallbackMethod(value) {
		this.setState({ title: value });
	}

	render() {
		const { title } = this.state;
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							{this.state.page === "add" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faPodcast} />
										<span data-testid="promiseLandPageTitle">
											{" "}
											Contextual Media -{" "}
											{title != "" ? Capitalize(title) : "Create New"}
										</span>
									</h2>
									<hr />
									<PromiseLandDetail
										callback={this.handleCallbackMethod}
										id={this.state.id}
									/>
								</div>
							)}
							{this.state.page == "detail" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faPodcast} />
										<span data-testid="promiseLandPageTitle">
											{" "}
											Contextual Media - {title} Details
										</span>
									</h2>
									<hr />
									<PromiseLandDetail
										callback={this.handleCallbackMethod}
										id={this.state.id}
									/>
								</div>
							)}
							{this.state.page == "" && this.state.isView && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faPodcast} />
										<span data-testid="promiseLandPageTitle"> Contextual Media</span>
									</h2>
									<hr />
									<PromiseLandList />
								</div>
							)}
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default PromiseLandPageComponent;
